var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 150,
    viewBox: "0 0 173 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x2014_\xC3\x8E\xC3\x93\xC3\x88_x5F_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.67427 2.57031C4.85424 2.57031 2.57031 4.85424 2.57031 7.67427V106.419C2.57031 109.239 4.85424 111.523 7.67427 111.523H164.656C167.476 111.523 169.76 109.239 169.76 106.419V7.67427C169.76 4.85424 167.476 2.57031 164.656 2.57031H7.67427Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51 146.5L61.2106 111.501",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M121.21 146.5L111 111.501",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.1528 146.73H158.678",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.409 56.8046L18.9175 36.0583L55.409 15.3193L91.9004 36.0583L55.409 56.8046Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M55.409 56.8047V98.7673L19.7694 78.0283L18.9175 36.0583",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M55.4092 98.7673L91.0488 78.0283L91.9007 36.0583",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M106.353 39.4292H126.791V28.2739",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M104.921 73.688H122.407V85.3353",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M91.7681 56.5549H137.204",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M126.791 28.2665C131.074 28.2665 134.546 24.7944 134.546 20.5114C134.546 16.2284 131.074 12.7563 126.791 12.7563C122.508 12.7563 119.036 16.2284 119.036 20.5114C119.036 24.7944 122.508 28.2665 126.791 28.2665Z",
    fill: "#335CFF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M151.142 62.0435C154.171 59.0149 154.171 54.1047 151.142 51.0761C148.114 48.0476 143.204 48.0476 140.175 51.0761C137.147 54.1047 137.147 59.0149 140.175 62.0435C143.204 65.072 148.114 65.072 151.142 62.0435Z",
    fill: "#335CFF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M122.406 100.846C126.689 100.846 130.162 97.3735 130.162 93.0905C130.162 88.8075 126.689 85.3354 122.406 85.3354C118.123 85.3354 114.651 88.8075 114.651 93.0905C114.651 97.3735 118.123 100.846 122.406 100.846Z",
    fill: "#335CFF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.da29db34411bd5747940e4be6d0715bb.svg";
export { ForwardRef as ReactComponent };